import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { BaseComponents } from '../base.component';

@Injectable()
export class GetLandingPopupService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService
  ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  public landingpopup:any = []

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector() {
    const url = `${environment.endpointBackend}/api/query/getLandingPopup`;
    const body = null;
    console.log(url);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec() {
    const self = this;
    return new Promise(function(resolve, reject) {
      if(!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()){
        self.connector().subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            //store ข้อมูลผลิตภัณฑ์ประกัน
            if(self.landingpopup.length==0 && res['body']['status']){
              self.landingpopup = res['body']['data']
              //console.log(self.securityGroup)
            }
            resolve(self.output(res['body']));
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus:  401,
          message: 'token is expired'
        });
      }
    });
  }
}
